export default {"src":"/_next/static/media/so.75115302.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};